import React from "react";



const FooterLogo =()=>{


   return(
    <div className="flex justify-content-center align-items-center mt-6 footer-bank-logos">
            <img className="h-[30px]" src="/bankIcons/ssl.png"  width={"auto"}  />
            <img className="h-[20px] ml-2"   src="/bankIcons/visa.svg"    />
            <img className="h-[30px] ml-2"  src="/bankIcons/mastercard-footer.svg"    />

    </div>
   );
}

export default FooterLogo;